/*
 * Levels Beyond CONFIDENTIAL
 *
 * Copyright 2003 - 2020 Levels Beyond Incorporated
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the
 * property of Levels Beyond Incorporated and its suppliers, if
 * any. The intellectual and technical concepts contained herein
 * are proprietary to Levels Beyond Incorporated and its suppliers
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this
 * material is unlawful and strictly forbidden unless prior
 * written permission is obtained from Levels Beyond Incorporated.
 */

/**
 * Created by richardwilliams on 3/31/15.
 */

function EndPointServiceConstructor(
    this: JS5Object,
    _: JS5Object,
    $window: JS5Object,
    appUriConfig: JS5Object,
) {
    const setDefaultWFCConfig = () => {
        //
        // This should only be used while running unit tests.
        //
        const defaultWFCConfig = {
            reachengineServerUrl: 'https://localhost',
            liveClippingServerUrl: 'https://localhost/liveclipping/api',
            liveClippingMediaUrl: 'https://localhost/liveclipping/hls',
            asperaConnectSdkPath: 'https://localhost/connect/v4'
        };

        if (!$window.hasOwnProperty('__wfcConfig')) {
            console.warn(`$window.__wfcConfig not defined; using defaults`);
            $window.__wfcConfig = $window.__wfcConfig || {};
            Object.assign($window.__wfcConfig, defaultWFCConfig);
        }
    };

    setDefaultWFCConfig();

    this.reachengineServerUrl = $window.__wfcConfig.reachengineServerUrl;
    this.liveClippingServerUrl = $window.__wfcConfig.liveClippingServerUrl;
    this.liveClippingMediaUrl = $window.__wfcConfig.liveClippingMediaUrl;
    this.webProxyMp4Url = $window.__wfcConfig.webProxyMp4Url;
    this.proxyUrl = $window.__wfcConfig.proxyUrl;
    this.asperaConnectSdkPath = $window.__wfcConfig.asperaConnectSdkPath;
    this.asperaConnectDestinationHost = $window.__wfcConfig.asperaConnectDestinationHost;

    this.acceptProfileEndPoint = this.reachengineServerUrl + appUriConfig.acceptProfilesUri;
    this.aggregationEndPoint = this.reachengineServerUrl + appUriConfig.aggregationUri;
    this.assetContentTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.assetContentTemplatesUri;
    this.artworkEndpoint = this.reachengineServerUrl + appUriConfig.artworkUri;
    this.breakPrePostRollEndpoint = this.reachengineServerUrl + appUriConfig.breakPrePostRollUri;
    this.calendarsEndpoint = this.reachengineServerUrl + appUriConfig.calendarsUri;
    this.categoriesEndpoint = this.reachengineServerUrl + appUriConfig.categoriesUri;
    this.captionsEndpoint = this.reachengineServerUrl + appUriConfig.captionsUri;
    this.checkInEndpoint = this.reachengineServerUrl + appUriConfig.checkInUri;
    this.clipEndpoint = this.reachengineServerUrl + appUriConfig.clipsUri;
    this.collaboratorsEndPoint = this.reachengineServerUrl + appUriConfig.collaboratorsUri;
    this.componentInventoryEndPoint = this.reachengineServerUrl + appUriConfig.componentInventoryUri;
    this.conditionalTemplateEndPoint = this.reachengineServerUrl + appUriConfig.conditionalTemplatesUri;
    this.contactsEndPoint = this.reachengineServerUrl + appUriConfig.contactsUri;
    this.contentEndPoint = this.reachengineServerUrl + appUriConfig.contentUri;
    this.dashboardEndpoint = this.reachengineServerUrl + appUriConfig.dashboardUri;
    this.deliveryTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.deliveryTemplatesUri;
    this.deliveryEndPoint = this.reachengineServerUrl + appUriConfig.deliveryUri;
    this.directoryEndPoint = this.reachengineServerUrl + appUriConfig.directoryUri;
    this.dynamicPropertiesEndPoint = this.reachengineServerUrl + appUriConfig.dynamicPropertiesUri;
    this.echoEndPoint = this.reachengineServerUrl + appUriConfig.echoUri;
    this.emailTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.emailTemplatesUri;
    this.enumEndPoint = this.reachengineServerUrl + appUriConfig.enumUri;
    this.eventNotificationsEndPoint = this.reachengineServerUrl + appUriConfig.eventNotificationsUri;
    this.externalMetadataSourcesEndPoint = this.reachengineServerUrl + appUriConfig.externalMetadataSourcesUri;
    this.externalMetadataLoggingEndPoint = this.reachengineServerUrl + appUriConfig.externalMetadataLoggingUri;
    this.externalMetadataQueueEndPoint = this.reachengineServerUrl + appUriConfig.externalMetadataQueueUri;
    this.execServersEndPoint = this.reachengineServerUrl + appUriConfig.execServersUri;
    this.fileSystemEndPoint = this.reachengineServerUrl + appUriConfig.fileSystemUri;
    this.ffmpegTemplateEndPoint = this.reachengineServerUrl + appUriConfig.ffmpegTemplatesUri;
    this.fileUploadEndPoint = this.reachengineServerUrl + appUriConfig.fileUploadUri;
    this.genresEndPoint = this.reachengineServerUrl + appUriConfig.genresUri;
    this.imageTemplatesEndpoint = this.reachengineServerUrl + appUriConfig.imageTemplatesUri;
    this.intermediateTemplateEndPoint = this.reachengineServerUrl + appUriConfig.intermediateTemplatesUri;
    this.inventoryEndPoint = this.reachengineServerUrl + appUriConfig.inventoryUri;
    this.languageEndPoint = this.reachengineServerUrl + appUriConfig.languageUri;
    this.liveClipEndPoint = this.reachengineServerUrl + appUriConfig.liveClipUri;
    this.livefeedsEndPoint = this.reachengineServerUrl + appUriConfig.livefeedsUri;
    this.macCaptionTemplatesEndpoint = this.reachengineServerUrl + appUriConfig.macCaptionTemplatesUri;
    this.mediaAssetEndpoint = this.reachengineServerUrl + appUriConfig.mediaAssetUri;
    this.mediaAssetDownloadEndpoint = this.reachengineServerUrl + appUriConfig.mediaAssetUri;
    this.mediaConversionTemplateEndpoint = this.reachengineServerUrl + appUriConfig.mediaConversionTemplateUri;
    this.mediaProfileEndPoint = this.reachengineServerUrl + appUriConfig.mediaProfile;
    this.metaGroupsEndpoint = this.reachengineServerUrl + appUriConfig.metaGroupsUri;
    this.metaPropertiesEndpoint = this.reachengineServerUrl + appUriConfig.metaPropsUri;
    this.networksEndPoint = this.reachengineServerUrl + appUriConfig.networksUri;
    this.packageAcceptTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.packageAcceptTemplatesUri;
    this.packageEndPoint = this.reachengineServerUrl + appUriConfig.packageUri;
    this.packageCategoriesEndpoint = this.reachengineServerUrl + appUriConfig.packageCategoriesUri;
    this.packageCreationTemplatesEndpoint = this.reachengineServerUrl + appUriConfig.packageCreationTemplatesUri;
    this.packageMediaInfoEndpoint = this.reachengineServerUrl + appUriConfig.packageMediaInfoUri;
    this.packageStatusNotificationsEndPoint = this.reachengineServerUrl + appUriConfig.packageStatusNotificationsUri;
    this.partnerEndPoint = this.reachengineServerUrl + appUriConfig.partnerUri;
    this.partnerPackagesEndPoint = this.reachengineServerUrl + appUriConfig.partnerPackagesUri;
    this.permissionsEndPoint = this.reachengineServerUrl + appUriConfig.permissionsUri;
    this.prePostRollEndpoint = this.reachengineServerUrl + appUriConfig.prePostRollUri;
    this.proxyEndPoint = this.reachengineServerUrl + appUriConfig.proxyUri;
    this.queuesEndpoint = this.reachengineServerUrl + appUriConfig.queuesUri;
    this.reachDynamicPropertiesEndPoint = this.reachengineServerUrl + appUriConfig.reachDynamicPropertiesUri;
    this.ratingsEndPoint = this.reachengineServerUrl + appUriConfig.ratingsUri;
    this.reachPermissionsEndpoint = this.reachengineServerUrl + appUriConfig.reachPermissionsUri;
    this.recordEndPoint = this.liveClippingServerUrl + appUriConfig.recordUri;
    this.reportEndpoint = this.reachengineServerUrl + appUriConfig.reportUri;
    this.repositoryRootsEndpoint = this.reachengineServerUrl + appUriConfig.repositoryRootsUri;
    this.roleEndPoint = this.reachengineServerUrl + appUriConfig.roleUri;
    this.samlEndPoint = this.reachengineServerUrl + appUriConfig.samlUri;
    this.securityRolesEndPoint = this.reachengineServerUrl + appUriConfig.securityRolesUri;
    this.serverInfoEndpoint = this.reachengineServerUrl + appUriConfig.serverInfoUri;
    this.systemMediainfoEndpoint = this.reachengineServerUrl + appUriConfig.mediainfoUri;
    this.temporaryFileUploadEndpoint = this.reachengineServerUrl + appUriConfig.temporaryFileUploadUri;
    this.territoriesEndpoint = this.reachengineServerUrl + appUriConfig.territoriesUri;
    this.transformTemplatesEndPoint = this.reachengineServerUrl + appUriConfig.transformTemplatesUri;
    this.userEndPoint = this.reachengineServerUrl + appUriConfig.userUri;
    this.virtualPathEndPoint = this.reachengineServerUrl + appUriConfig.virtualPathUri;
    this.watermarkEndpoint = this.reachengineServerUrl + appUriConfig.watermarkUri;
    this.workflowExecutionEndPoint = this.reachengineServerUrl + appUriConfig.workflowExecutionsUri;
    this.workflowFilesEndpoint = this.reachengineServerUrl + appUriConfig.workflowFilesUri;
}

angular
    .module('prism-ui.components.data')
    .service('EndPointService', EndPointServiceConstructor);
